export default __webpack_public_path__ + "static/media/portfolio.2268d6d0.png";